import { Component, ChangeDetectionStrategy, Input } from '@angular/core';

@Component({
  selector: 'icon',
  templateUrl: './icon.component.html',
  styleUrls: ['./icon.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class IconComponent {
  @Input() public name: string;
  @Input() public size: string;
  @Input() public color: string;

  get absUrl() {
    return window.location.href.split('#')[0];
  }
}
